export function PatternsH() {

    return {
        name: [
            'H_abstarct-dark-Transparent',
            'H_abstarct-pinkt',
            'H_abstract-balck',
            'H_Abstract-Gray-and-greent',
            'H_abstract-transparent',
            'H_adstract-gold',
            'H_adstract-gold-&-purple',
            'H_Big1',
            'H_Big2',
            'H_Big3',
            'H_Big4',
            'H_Big5',
            'H_Big6',
            'H_Big7',
            'H_Big8',
            'H_Big9copy',
            'H_Big10',
            'H_Big11',
            'H_Big12',
            'H_Big13',
            'H_Big14',
        ]
    }
}